import React, { useContext, useEffect, useState } from 'react';
import { FormDataContext } from '../../contexts/FormDataContext';
import { SectionHeading } from '../SectionHeading';
import {
  Autocomplete,
  Checkbox,
  createFilterOptions,
  TextField,
} from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

export const University = () => {
  const [schoolOptions, setSchoolOptions] = useState([]);
  const [initialSchoolOptions, setInitialSchoolOptions] = useState([]);
  const {
    schools,
    setSelectedSchools,
    preferencesFormDisabled,
    setIsFormDataChanged,
    selectedSchools,
  } = useContext(FormDataContext);

  const handleUniversityChange = (event, newValue) => {
    const schoolIds = newValue.map(school => school.id);
    setSelectedSchools(schoolIds);
    setIsFormDataChanged(true);
  };

  useEffect(() => {
    if (schools.length > 0) {
      const uniqueSchools = [...new Map(
        schools.map(item => [item.name, item])).values()
      ];
      let options = [];
      uniqueSchools.forEach(school => {
        options.push({id: school.id, name: school.name});
      });
      if (selectedSchools.length > 0) {
        setInitialSchoolOptions(options.filter(schoolOption => {
          return selectedSchools.includes(schoolOption.id);
        }));
      }
      setSchoolOptions(options);
    }
  }, [schools]);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const filterOptions = createFilterOptions({
    limit: 300
  })

  return (
    <>
      <SectionHeading>
        Your University
      </SectionHeading>
      {schoolOptions.length > 0 &&
        <Autocomplete
          defaultValue={initialSchoolOptions}
          disabled={preferencesFormDisabled}
          filterOptions={filterOptions}
          sx={{marginY: '10px'}}
          multiple
          onChange={handleUniversityChange}
          id="checkboxesComboUniversities"
          options={schoolOptions}
          disableCloseOnSelect
          getOptionLabel={(option) => option.name}
          placeholder="Select all that apply"
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.name}
            </li>
          )}
          renderInput={(params) => (
            <TextField {...params} label="Universities" placeholder="Select all that apply" />
          )}
        />
      }
    </>
  );
};